import { Button } from "antd";
import { signout } from "../App";

const IDPLoggedinIssue = () => {
    return (
        <div style={{ textAlign: 'center', paddingTop: '60px' }}>
            <img src="../../PermissionDenied.png" />
            <div style={{ textAlign: 'center', fontSize: 'xx-large', fontWeight: '600' }}>
                The ID token subject does not match with the current session's user.
            </div>

            <div style={{ textAlign: 'center', fontSize: 'large', fontWeight: '400', paddingBottom: "10px" }}>
                Looks like there is an active session for a different user in other browser tabs with the selected IDP. Please login again to end that user's session
            </div>

            <Button type="primary" size="large"
                onClick={signout}
            >
                Please login again
            </Button>
        </div>
    )
}

export default IDPLoggedinIssue;
